




















import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import { MIX_PANEL_CONSTANTS } from "@/resources/constants/mixpanel";
import { RED } from "@/resources/constants/busyReasons";
@Component({
  name: "other-reason-component",
})
export default class OtherReasonComponent extends mixins(NotificationEvent) {
  reason = "";
  get active(): boolean {
    return this.$store.getters["SidebarStore/getOpenOtherReason"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SidebarStore/setOpenOtherReasonAction", e);
  }
  saveReason() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];

    this.$store.dispatch("UserStore/updateUserStatusAction", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        availableStatus: RED.type,
        availableStatusReason: this.reason,
        emoji: "U+1F44B",
      },
      callback: (user) => {
        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
        this.reason = "";
        const space = this.$store.getters["SpaceStore/getSpace"];
        this.$mixpanel.track(MIX_PANEL_CONSTANTS.STATE_OFF, {
          distinct_id: spaceUser.superSpaceUser.user.id,
          "State type": this.reason,
          "Space ID": space.id || null,
          "Space Name": space.name || null,
          "Space Type": space.type || null,
          "Scenario Name": space.scenario.scenarioType.name || null,
          "Super Space Name": space.superSpace.name || null,
          "Super Space ID": space.superSpace.id || null,
        });
        this.$store.dispatch("SidebarStore/setOpenOtherReasonAction", false);
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.reasonUpdate")
        );
      },
      callbackError: (error) => {
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.errorMessages.reasonUpdate")
        );
      },
    });
  }
}
